// src/views/Inventory/FormPindahPos.js
import React, { useState } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Input,
  DatePicker,
  Button,
  Typography,
  Space,
  Modal,
  Table,
  message,
} from "antd";
import {
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import axiosInstance from "../../../configs"; // SESUAIKAN PATH

const { Text } = Typography;

export default function FormPindahPos() {
  const [form] = Form.useForm();

  const [saving, setSaving] = useState(false);

  // ====== STATE MODAL PILIH BARANG ======
  const [modalVisible, setModalVisible] = useState(false);
  const [itemStockLoading, setItemStockLoading] = useState(false);
  const [itemStockData, setItemStockData] = useState([]);

  // Confirmation Modal State
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);

  // Load item stock ketika modal dibuka
  const fetchItemStock = async () => {
    setItemStockLoading(true);
    try {
      const res = await axiosInstance.get("/item-stock", {
        params: {
          page: 1,
          limit: 100, // sesuaikan kalau mau paging beneran
        },
      });
      const list = res.data?.data || [];
      setItemStockData(list);
    } catch (err) {
      console.error(err);
      message.error("Gagal memuat data stok barang");
    } finally {
      setItemStockLoading(false);
    }
  };

  const openModalPilihBarang = () => {
    setModalVisible(true);
    fetchItemStock();
  };

  const closeModalPilihBarang = () => {
    setModalVisible(false);
  };

  // ====== HANDLE PILIH SATU BARANG UNTUK DITAMBAHKAN KE DETAIL ======
  const handleSelectItemFromModal = (record) => {
    const currentDetails = form.getFieldValue("details") || [];

    // mapping field dari /api/item-stock ke detail payload:
    // seri  -> record.seri
    // nopen -> record.nopen
    // item_code -> record.item_code
    // lot_asal -> record.lokasi_lot
    // jumlah_kemasan_asal -> record.jumlah_kemasan
    const newRow = {
      seri: record.seri,
      nopen: record.nopen,
      item_code: record.item_code,
      lot_asal: record.lokasi_lot,
      jumlah_kemasan_asal: record.jumlah_kemasan,
      lot_tujuan: "",
      jumlah_kemasan_tujuan: undefined,
    };

    form.setFieldsValue({
      details: [...currentDetails, newRow],
    });

    message.success("Barang berhasil ditambahkan ke daftar pindah pos");
    closeModalPilihBarang();
  };

  // ====== SUBMIT FORM KE API /pindah-pos ======
  const handleFinish = async (values) => {
    const details = values.details || [];

    if (!details.length) {
      message.error("Minimal harus ada satu baris detail pindah pos");
      return;
    }

    setPendingValues(values);
    setConfirmVisible(true);
  };

  const handleConfirmSubmit = async () => {
    const values = pendingValues;
    const details = values.details || [];
    const nowIso = new Date().toISOString();

    const headerPayload = {
      id_pindah_lot: 0,
      no_pindah_lot: values.no_pindah_lot,
      tanggal_pindah_lot: values.tanggal_pindah_lot
        ? dayjs(values.tanggal_pindah_lot).format("YYYY-MM-DD")
        : null,
      catatan: values.catatan || 0,
      created_by: "1",
      created_at: nowIso,
    };

    const detailsPayload = details.map((row, idx) => ({
      id_pindah_lot_detail: 0,
      id_pindah_lot: 0,
      seri: row.seri || idx + 1,
      nopen: row.nopen,
      item_code: row.item_code,
      lot_asal: row.lot_asal,
      jumlah_kemasan_asal: Number(row.jumlah_kemasan_asal) || 0,
      lot_tujuan: row.lot_tujuan,
      jumlah_kemasan_tujuan: Number(row.jumlah_kemasan_tujuan) || 0,
      created_by: "1",
      created_at: nowIso,
    }));

    const payload = {
      header: headerPayload,
      details: detailsPayload,
    };

    try {
      setSaving(true);
      await axiosInstance.post("/pindah-lot", payload);
      message.success("Data pindah pos / pindah lot berhasil disimpan");

      form.resetFields();
      setConfirmVisible(false);
    } catch (err) {
      console.error(err);
      message.error("Gagal menyimpan data pindah pos");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    window.history.back();
  };

  // ====== KOLOM TABLE MODAL ITEM-STOCK ======
  const itemStockColumns = [
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: "Item Code",
      dataIndex: "item_code",
      key: "item_code",
    },
    {
      title: "Seri",
      dataIndex: "seri",
      key: "seri",
      width: 80,
    },
    {
      title: "Nopen",
      dataIndex: "nopen",
      key: "nopen",
      width: 120,
    },
    {
      title: "Jumlah Kemasan",
      dataIndex: "jumlah_kemasan",
      key: "jumlah_kemasan",
      width: 140,
    },
    {
      title: "Lot / Lokasi",
      dataIndex: "lokasi_lot",
      key: "lokasi_lot",
      width: 120,
    },
    {
      title: "Aksi",
      key: "action",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Button type="link" onClick={() => handleSelectItemFromModal(record)}>
          Pilih
        </Button>
      ),
    },
  ];

  return (
    <>
      <Card
        className="kt-portlet"
        bodyStyle={{ padding: 24 }}
        style={{
          borderRadius: 16,
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          border: "1px solid #F3F6F9",
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{
            tanggal_pindah_lot: dayjs(),
            details: [],
          }}
        >
          {/* ===== HEADER TITLE ===== */}
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: 16 }}
          >
            <Col>
              <Typography.Title level={3} style={{ marginBottom: 4 }}>
                Form Pindah Pos / Pindah Lot
              </Typography.Title>
              <Text type="secondary">
                Catat perpindahan posisi barang antar lot / rak.
              </Text>
            </Col>
          </Row>

          {/* ===== HEADER FORM ===== */}
          <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item
                label={<Text strong>No Pindah Lot</Text>}
                name="no_pindah_lot"
                rules={[
                  { required: true, message: "No Pindah Lot wajib diisi" },
                ]}
              >
                <Input placeholder="Misal: PDL-251129001" />
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
              <Form.Item
                label={<Text strong>Tanggal Pindah Lot</Text>}
                name="tanggal_pindah_lot"
                rules={[
                  { required: true, message: "Tanggal pindah wajib diisi" },
                ]}
              >
                <DatePicker style={{ width: "100%" }} format="DD MMMM YYYY" />
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
              <Form.Item label={<Text strong>Catatan</Text>} name="catatan">
                <Input placeholder="Catatan pindah lot (opsional)" />
              </Form.Item>
            </Col>
          </Row>

          {/* ===== TABEL DETAIL PINDAH POS ===== */}
          <Card
            bodyStyle={{ padding: 0 }}
            style={{
              marginTop: 8,
              borderRadius: 4,
              border: "1px solid #E4E6EF",
              overflow: "hidden",
            }}
          >
            {/* Header kolom ala Metronic */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "0.6fr 1.4fr 2.2fr 1.4fr 1.8fr 1.4fr 1.8fr 0.8fr",
                background: "#F3F6F9",
                padding: "8px 16px",
                fontWeight: 600,
                fontSize: 13,
                alignItems: "center",
              }}
            >
              <div>SERI</div>
              <div>NOPEN</div>
              <div>ITEM CODE</div>
              <div>LOT ASAL</div>
              <div>JML KEMASAN ASAL</div>
              <div>LOT TUJUAN</div>
              <div>JML KEMASAN TUJUAN</div>
              <div style={{ textAlign: "center" }}>AKSI</div>
            </div>

            <Form.List name="details">
              {(fields, { remove }) => (
                <>
                  {fields.map((field, index) => (
                    <div
                      key={field.key}
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "0.6fr 1.4fr 2.2fr 1.4fr 1.8fr 1.4fr 1.8fr 0.8fr",
                        padding: "8px 16px",
                        borderTop: "1px solid #E4E6EF",
                        alignItems: "center",
                      }}
                    >
                      {/* SERI (dibaca saja dari field.seri) */}
                      <Form.Item
                        {...field}
                        name={[field.name, "seri"]}
                        fieldKey={[field.fieldKey, "seri"]}
                        style={{ marginBottom: 0, paddingRight: 8 }}
                      >
                        <Input disabled placeholder="Seri" />
                      </Form.Item>

                      {/* NOPEN */}
                      <Form.Item
                        {...field}
                        name={[field.name, "nopen"]}
                        fieldKey={[field.fieldKey, "nopen"]}
                        style={{ marginBottom: 0, paddingRight: 8 }}
                      >
                        <Input disabled placeholder="Nopen" />
                      </Form.Item>

                      {/* ITEM CODE */}
                      <Form.Item
                        {...field}
                        name={[field.name, "item_code"]}
                        fieldKey={[field.fieldKey, "item_code"]}
                        style={{ marginBottom: 0, paddingRight: 8 }}
                      >
                        <Input disabled placeholder="Item Code" />
                      </Form.Item>

                      {/* LOT ASAL */}
                      <Form.Item
                        {...field}
                        name={[field.name, "lot_asal"]}
                        fieldKey={[field.fieldKey, "lot_asal"]}
                        style={{ marginBottom: 0, paddingRight: 8 }}
                      >
                        <Input disabled placeholder="Lot Asal" />
                      </Form.Item>

                      {/* JML KEMASAN ASAL */}
                      <Form.Item
                        {...field}
                        name={[field.name, "jumlah_kemasan_asal"]}
                        fieldKey={[field.fieldKey, "jumlah_kemasan_asal"]}
                        style={{ marginBottom: 0, paddingRight: 8 }}
                      >
                        <Input
                          disabled
                          type="number"
                          placeholder="Jumlah Kemasan Asal"
                        />
                      </Form.Item>

                      {/* LOT TUJUAN (editable) */}
                      <Form.Item
                        {...field}
                        name={[field.name, "lot_tujuan"]}
                        fieldKey={[field.fieldKey, "lot_tujuan"]}
                        style={{ marginBottom: 0, paddingRight: 8 }}
                        rules={[
                          { required: true, message: "Lot tujuan wajib" },
                          {
                            pattern: /^[A-S]\.[1-3]\.\d{1,2}$/,
                            message: "Format: Rak.Lantai.Kolom"
                          }
                        ]}
                      >
                        <Input
                          placeholder="Rak.Lantai.Kolom"
                          onBlur={(e) => {
                            let raw = e.target.value.toUpperCase().trim().replace(/\s+/g, '');
                            if (!raw) return;

                            let formatted = raw;

                            // Already valid: A.1.1
                            if (/^[A-S]\.[1-3]\.\d{1,2}$/.test(formatted)) {
                              // OK
                            }
                            // B23 -> B.2.3 (Row + Level + Col)
                            else if (/^[A-S][1-3]\d{1,2}$/.test(formatted)) {
                              const row = formatted[0];
                              const level = formatted[1];
                              const col = formatted.slice(2);
                              formatted = `${row}.${level}.${col}`;
                            }
                            // A.23 -> A.2.3 (Row.Level+Col)
                            else if (/^[A-S]\.[1-3]\d{1,2}$/.test(formatted)) {
                              const row = formatted[0];
                              const level = formatted[2];
                              const col = formatted.slice(3);
                              formatted = `${row}.${level}.${col}`;
                            }
                            // A2.3 -> A.2.3 (Row+Level.Col)
                            else if (/^[A-S][1-3]\.\d{1,2}$/.test(formatted)) {
                              formatted = formatted[0] + '.' + formatted.slice(1);
                            }

                            // Update field value
                            const details = form.getFieldValue("details") || [];
                            if (details[field.name]) {
                              details[field.name].lot_tujuan = formatted;
                              form.setFieldsValue({ details });
                              setTimeout(() => {
                                form.validateFields([["details", field.name, "lot_tujuan"]]);
                              }, 0);
                            }
                          }}
                        />
                      </Form.Item>

                      {/* JML KEMASAN TUJUAN (editable) */}
                      <Form.Item
                        {...field}
                        name={[field.name, "jumlah_kemasan_tujuan"]}
                        fieldKey={[field.fieldKey, "jumlah_kemasan_tujuan"]}
                        style={{ marginBottom: 0, paddingRight: 8 }}
                        rules={[
                          {
                            required: true,
                            message: "Jumlah kemasan tujuan wajib diisi",
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          placeholder="Jumlah Kemasan Tujuan"
                        />
                      </Form.Item>

                      {/* AKSI - HAPUS ROW */}
                      <div style={{ textAlign: "center" }}>
                        <Button
                          type="text"
                          icon={<DeleteOutlined style={{ color: "#F64E60" }} />}
                          onClick={() => remove(field.name)}
                        />
                      </div>
                    </div>
                  ))}

                  {/* Jika belum ada detail */}
                  {fields.length === 0 && (
                    <div
                      style={{
                        padding: "12px 16px",
                        borderTop: "1px solid #E4E6EF",
                        color: "#B5B5C3",
                        fontStyle: "italic",
                      }}
                    >
                      Belum ada barang yang dipindahkan. Klik{" "}
                      <b>Pilih Barang</b> untuk menambah.
                    </div>
                  )}
                </>
              )}
            </Form.List>
          </Card>

          {/* ===== ACTIONS BAWAH TABEL ===== */}
          <Row justify="space-between" align="middle" style={{ marginTop: 16 }}>
            <Col>
              <Button icon={<SearchOutlined />} onClick={openModalPilihBarang}>
                Pilih Barang dari Stok
              </Button>
            </Col>
            <Col>
              <Space>
                <Button onClick={handleCancel}>Batal</Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={saving}
                  style={{
                    background: "#1BC5BD",
                    borderColor: "#1BC5BD",
                    minWidth: 140,
                    fontWeight: 600,
                  }}
                >
                  Simpan
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Card>

      {/* ===== MODAL PILIH BARANG DARI ITEM-STOCK ===== */}
      <Modal
        title="Pilih Barang Dari Stok"
        open={modalVisible}
        onCancel={closeModalPilihBarang}
        footer={null}
        width={900}
      >
        <Table
          rowKey="id_item_stock"
          loading={itemStockLoading}
          columns={itemStockColumns}
          dataSource={itemStockData}
          pagination={false}
          size="small"
        />
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        title="Konfirmasi Pindah Lot"
        open={confirmVisible}
        onOk={handleConfirmSubmit}
        onCancel={() => setConfirmVisible(false)}
        okText="Ya, Simpan"
        cancelText="Batal"
        confirmLoading={saving}
        width={600}
      >
        {pendingValues && (
          <div>
            <p>Apakah Anda yakin ingin menyimpan data pindah lot ini?</p>
            <div style={{ background: "#f5f5f5", padding: 10, borderRadius: 4, marginBottom: 16 }}>
              <p style={{ margin: 0 }}>
                <strong>No Pindah Lot:</strong> {pendingValues.no_pindah_lot}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Tanggal:</strong>{" "}
                {pendingValues.tanggal_pindah_lot
                  ? pendingValues.tanggal_pindah_lot.format("DD MMMM YYYY")
                  : "-"}
              </p>
            </div>

            <Text strong>Detail Barang:</Text>
            <div style={{ maxHeight: 200, overflowY: "auto", marginTop: 8, border: "1px solid #f0f0f0" }}>
              <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
                <thead style={{ background: "#fafafa", position: "sticky", top: 0 }}>
                  <tr>
                    <th style={{ padding: "4px 8px", textAlign: "left", borderBottom: "1px solid #f0f0f0" }}>Item Code</th>
                    <th style={{ padding: "4px 8px", textAlign: "left", borderBottom: "1px solid #f0f0f0" }}>Lot Asal</th>
                    <th style={{ padding: "4px 8px", textAlign: "left", borderBottom: "1px solid #f0f0f0" }}>Lot Tujuan</th>
                    <th style={{ padding: "4px 8px", textAlign: "right", borderBottom: "1px solid #f0f0f0" }}>Jml</th>
                  </tr>
                </thead>
                <tbody>
                  {(pendingValues.details || []).map((d, idx) => (
                    <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                      <td style={{ padding: "4px 8px" }}>{d.item_code}</td>
                      <td style={{ padding: "4px 8px" }}>{d.lot_asal}</td>
                      <td style={{ padding: "4px 8px" }}>{d.lot_tujuan}</td>
                      <td style={{ padding: "4px 8px", textAlign: "right" }}>{d.jumlah_kemasan_tujuan}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
}
